import { render } from "./KitchenDashboard.vue?vue&type=template&id=4a73463c&scoped=true"
import script from "./KitchenDashboard.vue?vue&type=script&lang=js"
export * from "./KitchenDashboard.vue?vue&type=script&lang=js"

import "./KitchenDashboard.vue?vue&type=style&index=0&id=4a73463c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a73463c"]])

export default __exports__